
import {tApi}from 'tplus-api';
import '../commom/Challenger';
import CutRetailDto from './CutRetailDto';
export default class UnitApi {
    /**
   * 检验单据日期是否合法
   * @param {voucherDate} voucherDate
   */
  static async unitChange(dto,newUnit,changSource) {
    // $T.debugger();
    // let cutDto=dto.cut();
    return await tApi({ "RetailDTO": CutRetailDto(dto),"unitDTONew":newUnit,"changSource":changSource }, 'chanjet.RE.INewRetail.UnitChange', false, false);
  }
}